/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import ServicesList from "./ServicesList";
import ServicesDetails from "./ServicesDetails";
import { Link } from "react-router-dom";
import { useLenis } from "../SmoothScroll";
import Faqs from "../Faqs";
import { Helmet } from "react-helmet-async";
export default function MainservicePage() {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  const faqs = [
    {
      question:
        "What imaging services are available at Citrus Diagnostic Center in Crystal River, FL?",
      answer:
        "Citrus Diagnostic Center offers a full range of outpatient diagnostic imaging services at our Crystal River, Florida location, including: MRI (Magnetic Resonance Imaging), CT Scan (Computed Tomography), PET/CT (Positron Emission Tomography combined with CT), X-Ray, Ultrasound (general, vascular/Doppler, thyroid, and breast), Echocardiography (cardiac ultrasound), Nuclear Medicine, DEXA bone density scanning, and Mammography. All studies are performed by licensed technologists and interpreted by our board-certified, on-site radiologist.",
    },
    {
      question: "Do I need a separate appointment for each type of imaging?",
      answer:
        "In most cases, yes - each imaging modality requires its own scheduled appointment due to specific equipment, preparation requirements, and technologist expertise. However, if your physician has ordered multiple studies, our scheduling team will do their best to coordinate your appointments on the same day or consecutive days to minimize trips to our Crystal River facility.",
    },
    {
      question: "How do I know which imaging test my doctor has ordered?",
      answer:
        "Your physician's order will specify the exact imaging study recommended. Common orders include MRI of the brain, spine, or joints; CT of the chest, abdomen, or pelvis; ultrasound of the abdomen, pelvis, or thyroid; PET/CT for oncology; or mammography for breast screening. If you are unsure what was ordered, our staff can help clarify when you call to schedule.",
    },
    {
      question:
        "Does Citrus Diagnostic Center offer imaging for auto accident or personal injury patients?",
      answer:
        "Yes. Citrus Diagnostic Center provides MRI and other diagnostic imaging services for patients involved in auto accidents, slip and fall incidents, and workplace injuries covered under Personal Injury Protection (PIP), workers' compensation, or personal injury legal cases. We work with attorneys, case managers, and claims adjusters and can provide documentation and imaging records as required.",
    },
    {
      question:
        "Are imaging costs at Citrus Diagnostic Center lower than at a hospital?",
      answer:
        "Yes, in most cases significantly so. As a physician-owned independent outpatient imaging center, Citrus Diagnostic Center operates with lower overhead than hospital outpatient departments, and those savings are passed on to patients and insurers. Studies show that the same MRI or CT scan can cost two to ten times more at a hospital outpatient department compared to a freestanding outpatient imaging center like ours - with no difference in image quality or diagnostic accuracy.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Medical Imaging Modalities and Services | MRI, CT, X-Ray Center
        </title>
        <meta
          name="description"
          content="What Imaging services are offered? MRI, CT, and X-ray performed with structured methods and interpreted by radiologists to ensure consistent, accurate results.
"
        />
        <meta
          name="keywords"
          content="medical diagnostic imaging
center for diagnostic imaging
diagnostic imaging services
imaging and diagnostics
best imaging center


"
        />
      </Helmet>

      <div>
        <div className="text-center xl:pt-48 lg:pt-32 pt-20 max-w-7xl mx-auto">
          {" "}
          <div className="pb-8">
            <h1 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal capitalize">
              Imaging Services
            </h1>
            <p className=" text-[#f5f5f5] font-normal capitalize  text-center">
              Comprehensive imaging. One trusted center.
            </p>
          </div>
          <div className=" w-[80%] mx-auto">
            <p>
              Citrus Diagnostic Center is a{" "}
              <span className="font-extrabold ">
                full-service outpatient medical imaging center
              </span>
              , providing advanced diagnostic imaging across all major
              modalities. Every study is performed using modern technology and
              interpreted by{" "}
              <span className="font-extrabold ">
                board-certified, fellowship-trained radiologists
              </span>
              .
            </p>
            <p className="py-5">
              This page provides an overview of{" "}
              <span className="font-extrabold ">
                all imaging services we offer
              </span>
              , with links to specialized pages where appropriate.
            </p>
          </div>
        </div>
        <div className="py-10 xl:py-28">
          {/* Services List Component */}
          <ServicesList />
        </div>
        <ServicesDetails />

        <div className="lg:w-[80%] w-[90%] mx-auto lg:pt-16 pt-10 ">
          <Faqs faqs={faqs} />
        </div>
        <div className="text-center text-white pt-28  max-w-7xl mx-auto">
          <h2 className="font-heading lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal capitalize  px-2 md:px-0 pb-5 ">
            One Center. Every Modality.
          </h2>
          <p className=" w-[80%] mx-auto space-y-6">
            From preventive screening to advanced diagnostic evaluation, Citrus
            Diagnostic Center delivers{" "}
            <span className="font-extrabold ">
              comprehensive imaging under one roof
            </span>
            -guided by expertise, independence, and patient-first care.
          </p>
          <div className="flex justify-center items-center mt-4 py-8">
            <div
              style={{
                background: `
              linear-gradient(90deg,
            #3d0e26 0%,
            #5a1f33 1%,
            #8b5e3c 40%,
            #8b5e3c 70%,
            #5a1f33 95%,
            #330a16 100%
          )
            `,
              }}
              className="flex justify-center items-center xl:w-[668px] flex-col gap-2 py-8 px-6 xl:px-8 rounded-xl "
            >
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
                Ready to Get Started?
              </h2>

              <div className="pt-5 pb-5">
                <Link
                  data-aos="fade-up"
                  to="/contact"
                  aria-label="Schedule Now"
                  className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
                >
                  Schedule Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
